import React from "react";

function AudioRecordIcon(props) {
  return (
    <svg
      width="51"
      height="51"
      viewBox="0 0 51 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="50.7761" height="50.7761" fill="#0D0D0F" />
      <path
        d="M50.7761 25.3881C50.7761 39.4095 39.4095 50.7761 25.3881 50.7761C11.3666 50.7761 0 39.4095 0 25.3881C0 11.3666 11.3666 0 25.3881 0C39.4095 0 50.7761 11.3666 50.7761 25.3881ZM5.87546 25.3881C5.87546 36.1646 14.6115 44.9007 25.3881 44.9007C36.1646 44.9007 44.9007 36.1646 44.9007 25.3881C44.9007 14.6115 36.1646 5.87546 25.3881 5.87546C14.6115 5.87546 5.87546 14.6115 5.87546 25.3881Z"
        fill="#0D0D0F"
      />
      <path
        d="M5.87546 25.3881C5.87546 36.1646 14.6115 44.9007 25.3881 44.9007C36.1646 44.9007 44.9007 36.1646 44.9007 25.3881C44.9007 14.6115 36.1646 5.87546 25.3881 5.87546C14.6115 5.87546 5.87546 14.6115 5.87546 25.3881Z"
        fill="#1C1F25"
      />
      <path
        d="M36.6271 30.3263C35.4258 32.0418 33.8356 33.4487 31.9865 34.4319C30.1373 35.4152 28.0817 35.9468 25.9877 35.9833C23.8937 36.0199 21.8208 35.5603 19.9385 34.6422C18.0561 33.7242 16.4178 32.3736 15.1574 30.701L17.6102 28.8527C18.5789 30.1382 19.8381 31.1762 21.2848 31.8818C22.7315 32.5874 24.3247 32.9406 25.9341 32.9125C27.5435 32.8844 29.1234 32.4759 30.5446 31.7202C31.9658 30.9645 33.188 29.8832 34.1113 28.5647L36.6271 30.3263Z"
        fill="#0C8CE9"
      />
      <path
        fillRrule="evenodd"
        clipRule="evenodd"
        d="M25.3881 15.1123C23.385 15.1123 21.7612 16.7361 21.7612 18.7392V25.9929C21.7612 27.996 23.385 29.6198 25.3881 29.6198C27.3912 29.6198 29.015 27.996 29.015 25.9929V18.7392C29.015 16.7361 27.3912 15.1123 25.3881 15.1123ZM25.3882 17.5302C24.7205 17.5302 24.1792 18.0715 24.1792 18.7392V25.9929C24.1792 26.6606 24.7205 27.2019 25.3882 27.2019C26.0559 27.2019 26.5971 26.6606 26.5971 25.9929V18.7392C26.5971 18.0715 26.0559 17.5302 25.3882 17.5302Z"
        fill="#0C8CE9"
      />
    </svg>
  );
}

export default AudioRecordIcon;
